import { render, staticRenderFns } from "./GSettingView.vue?vue&type=template&id=08a8bfd9&scoped=true&"
import script from "./GSettingView.vue?vue&type=script&lang=js&"
export * from "./GSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8bfd9",
  null
  
)

export default component.exports